// extracted by mini-css-extract-plugin
module.exports = {"plate":"plate_plate_3dXb4","serach":"plate_serach_2NlFj","total":"plate_total_269qJ","table":"plate_table_2k5K8","operation":"plate_operation_3SxkR","render":"plate_render_3UPni"};